import 'babel-polyfill';
import 'es6-promise/auto';

import Vue from 'vue'
import App from './App.vue'
import router from './router/routing';
import { user } from './user.js';

import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import VueMoment from 'vue-moment';
import moment from 'moment';
import VueMask from 'vue-the-mask';
import VueI18n from 'vue-i18n';
import VueCookie from 'vue-cookie';
import Multiselect from 'vue-multiselect';
import VueUploadComponent from 'vue-upload-component';
import VCalendar from 'v-calendar';
import IdleVue from 'idle-vue';
import {
  ValidationObserver,
  ValidationProvider,
  configure,
  extend
} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './style.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(VueMoment);
Vue.use(VueMask);
Vue.use(VueI18n);
Vue.use(VueCookie);
Vue.use(router);

library.add(faTimes);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);
Vue.component('file-upload', VueUploadComponent);
Vue.component('multiselect', Multiselect);

configure({
  classes: {
    invalid: 'is-invalid'
  }
});

extend('required', {
  ...required,
  message: 'required'
});

extend('muliptle-email', {
  message: 'valid_email',
  validate: (value) => {
    return validateEmails(value)
  }
})

function validateEmail(email) {
  // eslint-disable-next-line
  var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return reg.test(String(email));
}

const validateEmails = (emails = '') => {
  emails = emails.split(/[;,]/).map((x) => x.trim().toLocaleLowerCase());
  if (emails.length !== new Set(emails).size) return false;
  return emails.every(validateEmail);
};

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.filter('moment', function(value, format) {
  if (value === null || value === undefined || format === undefined) {
    return '';
  }

  if (format === 'from') {
    return moment(value).fromNow();
  }

  return moment(value).format(format);
});

const axiosConfig = {
  baseURL: process.env.VUE_APP_API_ROOT,
  timeout: 120 * 1000
};

Vue.prototype.$axios = axios.create(axiosConfig);

Vue.prototype.$axios.interceptors.request.use(
  async function(config) {
    var companyId = Vue.cookie.get('companyId');
    var selectedCustomers = Vue.cookie.get('selectedCustomers');

    config.headers['CompanyId'] = companyId;
    config.headers['Customers'] = selectedCustomers;

    try {
      let accessToken = await user.getApiAccessToken();
      if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
      }
    } catch (error) {
      console.error('Error getting access token:', error);
      // Don't add authorization header if token acquisition fails
      // This allows the request to proceed and be handled by the response interceptor
    }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

Vue.prototype.$axios.interceptors.response.use(
  function(response) {
    return response;
  },
  async function(error) {
    const originalRequest = error.config;
    
    // Handle invalid companyId
    if (error.response && error.response.data && error.response.data.message === 'Invalid companyId') { 
      console.log('Invalid companyId');
      router.push({
        name: 'selection'
      });
      return Promise.reject(error);
    }

    // Handle token expiration (401 Unauthorized or 403 Forbidden)
    if (error.response && (error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // Try to refresh the token
        const newToken = await user.getApiAccessToken();
        if (newToken) {
          // Update the authorization header with the new token
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          // Retry the original request
          return Vue.prototype.$axios(originalRequest);
        } else {
          // If no token is returned, redirect to login
          router.push({
            name: 'login'
          });
          return Promise.reject(error);
        }
      } catch (tokenError) {
        console.error('Token refresh failed:', tokenError);
        // If token refresh fails, redirect to login
        router.push({
          name: 'login'
        });
        return Promise.reject(tokenError);
      }
    }

    return Promise.reject(error);
  }
);
   

let selectedLocale = Vue.prototype.$cookie.get('selectedLocale');

if (selectedLocale == null) {
  var language =
    navigator.languages &&
    (navigator.languages[0] || // Chrome / Firefox
    navigator.language || // All browsers
      navigator.userLanguage); // IE <= 10

  if (language == null) {
    language = 'en';
  }

  selectedLocale = language.substring(0, 2);
}

const messages = {
  en: require('./lang/en.json'),
  fr: require('./lang/fr.json'),
  nl: require('./lang/nl.json')
};

const i18n = new VueI18n({
  locale: selectedLocale,
  fallbackLocale: 'en',
  messages
});

const eventsHub = new Vue();

const idleOptions = {
  eventEmitter: eventsHub,

  idleTime: 24 * 60 * 60000 // Azure AD default is also 12 hours so keep it the same
};

Vue.use(IdleVue, idleOptions);

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'nl-NL': {
      firstDayOfWeek: 1,
      masks: {
        L: 'DD-MM-YYYY' }
      }
    }
  });
 
  export const bus = new Vue();

new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>',
  onIdle() {
    user.signOut();
  }
});
